module.exports = __webpack_public_path__ + "static/media/assembly_V2.1df8215c.png";